/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import { ProTable } from "@ant-design/pro-table";
import enUS from "antd/locale/en_US";
import {
  Button,
  Select,
  message,
  Typography,
  Empty,
  Space,
  Input,
  Tag,
  Flex,
  Tooltip,
  DatePicker,
  Table,
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import "moment/locale/en-gb";
import "../UserCompon.css";
moment.locale("en");
const { Option } = Select;
const { Text } = Typography;
const { RangePicker } = DatePicker;

const VendorClock = () => {
  const tableRef = useRef();
  const [selectedType, setSelectedType] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiData, setApiData] = useState(null);
  const [accountData, setAccountData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [isSelectVisible, setIsSelectVisible] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [selectedTimestamp, setSelectedTimestamp] = useState(null);
  const [selectionType] = useState("checkbox");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 13,
  });
  const [filteredData, setFilteredData] = useState([]);
  const [tableHead, setTableHead] = useState({
    status: null,
    prop: null,
    workType: null,
    PropUnit: null,
    address: null,
    city: null,
    job: null,
    remark: null,
    requestBy: null,
    createBy: null,
    requestNo: null,
    vendorName: null,
    sCreateTime: null,
    sCompletionDate: null,
    eCreateTime: null,
    eCompletionDate: null,
    vendorId:null,
  });

  //  select
  const handleClear = () => {
    setSelectedAccount(null);
    setIsSelectVisible(false);
  };

  const handleChangeUpdata = (value, e) => {
    console.log("vendor:", value, e);
    setSelectedAccount(value);
    fetchData(1, 25,{ vendorId: value } );
  };

  const stepSearchChange = (value) => {
    console.log("stepSearchChange", value);
    getSearchVendor(value);
  };

  const getSearchVendor = async (content) => {
    try {
      const Maintenance = "Maintenance";
      const requestContent = content === undefined ? "" : content;
      const response = await http.get(
        `${api.getMaintenanceVendor}?content=${encodeURIComponent(requestContent)}&vendorType=${Maintenance}`
      );
      if (response && response.data) {
        const formattedData = response.data.map((item) => ({
          value: item.vendorId,
          label: item.name,
          // vendorId:item.vendorId
        }));
        setAccountData(formattedData);
      }
    } catch (err) {
      setError(err); // 捕获错误
    } finally {
      setLoading(false);
    }
  };

  const handleOk = (dates, e) => {
    if (dates && dates.length === 2) {
      const startDate = dates[0].format("MM/DD/YYYY");
      const endDate = dates[1].format("MM/DD/YYYY");
      const startTime = dates[0].valueOf();
      const endTime = dates[1].valueOf();
      console.log("dates......>", startTime, endTime);
      handleApiCall(startDate, endDate, startTime, endTime);
      setSelectedDateRange({
        startDate: dates[0],
        endDate: dates[1],
        startDateString: startDate,
        endDateString: endDate,
      });
    } else {
      return;
    }
  };
  const handleApiCall = async (startDate, endDate, startTime, endTime) => {
    console.log("Fetching data for:", startDate, endDate);

    setTableHead((prev) => {
      console.log("prev", prev);
      const updatedTableHead = {
        ...prev,
        sCreateTime: startTime,
        eCreateTime: endTime,
      };
      console.log("Updated tableHead:", updatedTableHead);
      fetchData(1, 25, updatedTableHead);
      return updatedTableHead;
    });
  };

  const handlePressEnterPropUnit = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 阻止表单提交
      e.stopPropagation();
      const inputValue = e.target.value;
      setTableHead((prev) => {
        const updatedTableHeadProp = { ...prev, propUnit: inputValue };
        fetchData(1, 25, updatedTableHeadProp);
        return updatedTableHeadProp;
      });
    }
  };
  const handlePressEnterAdd = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 阻止表单提交
      e.stopPropagation();
      const inputValue = e.target.value;
      setTableHead((prev) => {
        const updatedTableHeadAdd = { ...prev, address: inputValue };
        fetchData(1, 25, updatedTableHeadAdd);
        return updatedTableHeadAdd;
      });
    }
  };
  const handlePressEnterCity = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 阻止表单提交
      e.stopPropagation();
      const inputValue = e.target.value;
      setTableHead((prev) => {
        const updatedTableHeadCity = { ...prev, city: inputValue };
        fetchData(1, 25, updatedTableHeadCity);
        return updatedTableHeadCity;
      });
    }
  };
  const handlePressEnterJob = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 阻止表单提交
      e.stopPropagation();
      const inputValue = e.target.value;
      setTableHead((prev) => {
        const updatedTableHeadJob = { ...prev, job: inputValue };
        fetchData(1, 25, updatedTableHeadJob);
        return updatedTableHeadJob;
      });
    }
  };
  const handlePressEnterRemark = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 阻止表单提交
      e.stopPropagation();
      const inputValue = e.target.value;
      setTableHead((prev) => {
        const updatedTableHeadRemark = { ...prev, remark: inputValue };
        fetchData(1, 25, updatedTableHeadRemark);
        return updatedTableHeadRemark;
      });
    }
  };
  const handlePressEnterRequestNo = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 阻止表单提交
      e.stopPropagation();
      const inputValue = e.target.value;
      setTableHead((prev) => {
        const updatedTableHeadRemark = { ...prev, requestNo: inputValue };
        fetchData(1, 25, updatedTableHeadRemark);
        return updatedTableHeadRemark;
      });
    }
  };
  const handlePressEnterVendorName = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 阻止表单提交
      e.stopPropagation();
      const inputValue = e.target.value;
      setTableHead((prev) => {
        const updatedTableHeadRemark = { ...prev, vendorName: inputValue };
        fetchData(1, 25, updatedTableHeadRemark);
        return updatedTableHeadRemark;
      });
    }
  };

  const handlePressEnterRequestBy = (value) => {
    setTableHead((prev) => {
      const updatedTableHeadWork = { ...prev, requestBy: value };
      fetchData(1, 25, updatedTableHeadWork);
      return updatedTableHeadWork;
    });
  };
  const handlePressEnterCreateBy = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // 阻止表单提交
      e.stopPropagation();
      const inputValue = e.target.value;
      setTableHead((prev) => {
        const updatedTableHeadCreateBy = { ...prev, createBy: inputValue };
        fetchData(1, 25, updatedTableHeadCreateBy);
        return updatedTableHeadCreateBy;
      });
    }
  };
  const statusChange = (value) => {
    console.log(`selected ${value}`);
    setTableHead((prev) => {
      const updatedTableHead = { ...prev, status: value };
      fetchData(1, 25, updatedTableHead);
      return updatedTableHead;
    });
  };
  const statusChangeWork = (value) => {
    console.log(`selected ${value}`);
    setTableHead((prev) => {
      const updatedTableHeadWork = { ...prev, workType: value };
      fetchData(1, 25, updatedTableHeadWork);
      return updatedTableHeadWork;
    });
    console.log(tableHead);
  };

  // 定义列，包括输入框
  const initColumns = [
    {
      title: (text, record, index) => (
        <div>
          <div>Request No</div>
          <div>
            <Input
              placeholder="Search RequestNo"
              onClick={(e) => e.stopPropagation()} 
              onKeyDown={handlePressEnterRequestNo}
            />
          </div>
        </div>
      ),
      dataIndex: "requestNo",
      key: "requestNo",
      hidden: false,
      width:150,
      className: "custom-sort-header",
      align: "center",
      render: (text, record, index) => text,
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Status</div>
          <div>
            <Select
              defaultValue="All"
              placeholder="Select status"
              style={{
                width: 100,
              }}
              onClick={(e) => e.stopPropagation()}
              onChange={statusChange}
              options={[
                {
                  value: "",
                  label: "All",
                },
                {
                  value: "Pending",
                  label: "Pending",
                },
                {
                  value: "Quoted",
                  label: "Quoted",
                },
                {
                  value: "Assigned",
                  label: "Assigned",
                },
                {
                  value: "Approved",
                  label: "Approved",
                },
                {
                  value: "Review",
                  label: "Review",
                },
                {
                  value: "Ready To Pay",
                  label: "Ready To Pay",
                },
                {
                  value: "Document Only",
                  label: "Document Only",
                },
              ]}
            />
          </div>
        </div>
      ),
      dataIndex: "status",
      key: "status",
      align: "center",
      hidden: false,
      width: 110,

      className: "custom-sort-header",
      // align: 'center',
      render: (text, record, index) => {
        let statusText = "";
        let tagColor = "";
        if (text == "Pending") {
          statusText = "Pending";
          tagColor = "#dd4b39";
        } else if (text == "Quoted") {
          statusText = "Quoted";
          tagColor = "#dd4b39";
        } else if (text == "Assigned") {
          statusText = "Assigned";
          tagColor = "#dd4b39";
        } else if (text == "Approved") {
          statusText = "Approved";
          tagColor = "#dd4b39";
        } else if (text == "Review") {
          statusText = "Review";
          tagColor = "#dd4b39";
        } else if (text == "Ready To Pay") {
          statusText = "Ready To Pay";
          tagColor = "#00a65a";
        } else if (text == "Document Only") {
          statusText = "Document Only";
          tagColor = "#3c8dbc";
        }

        return (
          <a onClick={(e) => showModalOpen(record)}>
            <Tag color={tagColor}>{statusText}</Tag>
          </a>
        );
      },
    },

    {
      title: (text, record, index) => (
        <div>
          <div>Work Type</div>
          <div>
            <Select
              defaultValue="All"
              placeholder="Select status"
              style={{
                width: 100,
              }}
              onClick={(e) => e.stopPropagation()}
              onChange={statusChangeWork}
              options={[
                {
                  value: "",
                  label: "All",
                },
                {
                  value: "1",
                  label: "Maint.Woker",
                },
                {
                  value: "2",
                  label: "Contractor",
                },
              ]}
            />
          </div>
        </div>
      ),
      dataIndex: "workType",
      key: "workType",
      align: "center",
      hidden: false,
      width: 110,

      className: "custom-sort-header",
      render: (text, record, index) => {
        return text === null
          ? " "
          : text === 1
          ? "Maint.Woker"
          : text === 2
          ? "Contractor"
          : " ";
        // return (text === '1'?'Maint.Woker':text === '2'?'Contractor':' ');
      },
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Vendor Name</div>
          <div>
            <Input
              placeholder="Search Vendor Name"
              onClick={(e) => e.stopPropagation()} // 阻止冒泡事件
              onKeyDown={handlePressEnterVendorName}
            />
          </div>
        </div>
      ),
      dataIndex: "vendorName",
      key: "vendorName",
      hidden: false,
      width: 100,

      className: "custom-sort-header",
      align: "center",
      render: (text, record, index) => text,
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Comp.Date</div>
          <div>
            <Input
              placeholder="Search Completion Date"
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => handleInputChange(e.target.value, "status")}
            />
          </div>
        </div>
      ),
      dataIndex: "completionDate",
      key: "completionDate",
      hidden: false,
      width: 100,

      className: "custom-sort-header",
      align: "center",
      render: (text, record, index) => {
        if (isValidDate(text)) {
          return moment(text).format("MM/DD/YYYY");
        } else {
          return ""; 
        }
      },
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Prop-Unit</div>
          <div>
            <Input
              placeholder="Search Prop Unit"
              onClick={(e) => e.stopPropagation()}
              onKeyDown={handlePressEnterPropUnit}
            />
          </div>
        </div>
      ),
      dataIndex: "propUnit",
      key: "propUnit",
      hidden: false,
      width: 150,

      className: "custom-sort-header",
      align: "center",
      render: (text, record, index) => text,
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Unit Address</div>
          <div>
            <Input
              placeholder="Search Unit Address"
              onClick={(e) => e.stopPropagation()} // 阻止冒泡事件
              onKeyDown={handlePressEnterAdd}
            />
          </div>
        </div>
      ),
      dataIndex: "address",
      key: "address",
      width: 150,
      hidden: false,

      className: "custom-sort-header",
      align: "center",
      render: (text, record, index) => <div className="text-clamp">{text}</div>,
    },
    {
      title: (text, record, index) => (
        <div>
          <div>City</div>
          <div>
            <Input
              placeholder="Search City"
              onClick={(e) => e.stopPropagation()} // 阻止冒泡事件
              onKeyDown={handlePressEnterCity}
            />
          </div>
        </div>
      ),
      dataIndex: "city",
      key: "city",
      width: 100,
      hidden: false,
      className: "custom-sort-header",
      align: "center",
      render: (text, record, index) => text,
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Job</div>
          <div>
            <Input
              placeholder="Search status"
              onClick={(e) => e.stopPropagation()}
              onKeyDown={handlePressEnterJob}
            />
          </div>
        </div>
      ),
      dataIndex: "jobs",
      key: "jobs",
      hidden: false,
      className: "custom-sort-header",
      align: "center",
      width: 70,
      render: (text, record, index) => {
        return (
          <Flex gap="4px 0" wrap>
            {record.jobs.map((item, idx) => (
              <Tag color="blue" key={idx} bordered={false}>
                {item}
              </Tag>
            ))}
          </Flex>
        );
      },
    },
    {
      title: (text, record, index) => (
        <div>
          <div>Remark</div>
          <div>
            <Input
              placeholder="Search remark"
              onClick={(e) => e.stopPropagation()} // 阻止冒泡事件
              onKeyDown={handlePressEnterRemark}
            />
          </div>
        </div>
      ),
      dataIndex: "remark",
      key: "remark",
      hidden: false,
      width: 100,
      className: "custom-sort-header",
      align: "center",
      render: (text, record, index) => (
        <Tooltip title={` ${text}`} classNames="my-tooltip">
          <div
            className="text-clamp"
            style={{ whiteSpace: "normal", width: "100px" }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },

    {
      title: (text, record, index) => (
        <div>
          <div>Requested By</div>
          <div>
            <Select
              defaultValue="All"
              placeholder="Select status"
              style={{
                width: 90,
              }}
              onClick={(e) => e.stopPropagation()}
              onChange={handlePressEnterRequestBy}
              options={[
                {
                  value: "",
                  label: "All",
                },
                {
                  value: "1",
                  label: "Tenant",
                },
                {
                  value: "2",
                  label: "Manager",
                },
              ]}
            />
          </div>
        </div>
      ),
      dataIndex: "createByType",
      key: "createByType",
      align: "center",
      hidden: false,
      width: 100,
      className: "custom-sort-header",
      render: (text, record, index) => {
        return text == 1 ? "Tenant" : text == 2 ? "Manager" : "";
      },
    },
    {
      title: (text, record, index) => (
        <div>
          <div>CreateBy</div>
          <div>
            <Input
              placeholder="Search createBy"
              onClick={(e) => e.stopPropagation()} // 阻止冒泡事件
              onKeyDown={handlePressEnterCreateBy}
            />
          </div>
        </div>
      ),
      dataIndex: "createByName",
      key: "createByName",
      width: 100,
      hidden: false,
      className: "custom-sort-header",
      align: "center",
      render: (text, record, index) => text,
    },
    {
      title: (text, record, index) => (
        <div>
          <div> CreateTime</div>
          <Space direction="vertical">
            <RangePicker
              onChange={(dates) => handleOk(dates)}
              format="MM/DD/YYYY"
               onFocus={(e) => e.preventDefault()} // 阻止默认行为
                onBlur={(e) => e.preventDefault()} // 阻止默认行为
              />
        
          </Space>
        </div>
      ),
      dataIndex: "createTime",
      key: "createTime",
      width: 250,
      hidden: false,
      className: "custom-sort-header",
      align: "center",
      render: (text, record, index) => moment(text).format("MM/DD/YYYY HH:mm"),
    },
  ];
  const [columns, setColumns] = useState(initColumns);
  // 处理分页变化
  const handleTableChange = (pagination, filters) => {
    console.log("页码更新");
    console.log(filters);
    //table筛选
    fetchData(pagination.current, pagination.pageSize);
  };
  //列表
  const fetchData = async (page, pageSize, tableHead,) => {
    setTableLoading(true);
    try {
      const hasOtherSearchConditions = tableHead && Object.keys(tableHead).some(
        key => key !== 'vendorId' && tableHead[key]
      );
  
      // 只有当vendorId为空且没有其他搜索条件时才阻止请求
      if (!tableHead?.vendorId && !hasOtherSearchConditions) {
        setTableLoading(false);
        setFilteredData([]);
        setPagination(prev => ({
          ...prev,
          current: 1,
          total: 0,
          pageSize: pageSize,
        }));
        props.updateMessage([]);
        return;
      }
      console.log("======设置分页1");
      const response = await http.get(
        `${api.MaintenanceShow}?page=${page}&count=${pageSize}&vendorId=${
          tableHead && tableHead.vendorId ? tableHead.vendorId : ""
        }&type=${
          tableHead && tableHead.status ? tableHead.status : ""
        }&prop=${tableHead && tableHead.prop ? tableHead.prop : ""}&propUnit=${
          tableHead && tableHead.propUnit ? tableHead.propUnit : ""
        }&workType=${
          tableHead && tableHead.workType ? tableHead.workType : ""
        }&address=${
          tableHead && tableHead.address ? tableHead.address : ""
        }&city=${tableHead && tableHead.city ? tableHead.city : ""}&job=${
          tableHead && tableHead.job ? tableHead.job : ""
        }&remark=${
          tableHead && tableHead.remark ? tableHead.remark : ""
        }&requestBy=${
          tableHead && tableHead.requestBy ? tableHead.requestBy : ""
        }&createBy=${
          tableHead && tableHead.createBy ? tableHead.createBy : ""
        }&requestNo=${
          tableHead && tableHead.requestNo ? tableHead.requestNo : ""
        }&vendorName=${
          tableHead && tableHead.vendorName ? tableHead.vendorName : ""
        }&sCreateTime=${
          tableHead && tableHead.sCreateTime ? tableHead.sCreateTime : ""
        }&sCompletionDate=${
          tableHead && tableHead.sCompletionDate
            ? tableHead.sCompletionDate
            : ""
        }&eCreateTime=${
          tableHead && tableHead.eCreateTime ? tableHead.eCreateTime : ""
        }&eCompletionDate=${
          tableHead && tableHead.eCompletionDate
            ? tableHead.eCompletionDate
            : ""
        }`
      );
      const dataWithKey = (response.data.list || [])?.map((item) => ({
        ...item,
        key: item.id,
      }));
      console.log(dataWithKey);

      setTableLoading(false);
      setFilteredData(dataWithKey);
      setPagination((prev) => ({
        ...prev,
        current: page,
        total: response.data.total,
        pageSize: pageSize,
      }));
      console.log(pagination);
      props.updateMessage(dataWithKey);
    } catch (err) {
      setError(err); 
    } finally {
      setTableLoading(false);
    }
  };

  const rowSelection = {
    // getCheckboxProps: (record) => ({
    //   style: record.isEmpty ? { display: "none" } : {}, // 隐藏复选框
    //   disabled:
    //     record.status !== "Pending" ||
    //     (record.status === "Quoted" && materials_confirm_type === 2),
    // }),
    type: "radio",
    selectedRowKeys: selectedRowKeys || [],
    onChange: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    },
  };
  // 时间非空判断
  const isValidDate = (e) => {
    return e && !isNaN(new Date(e));
  };

  const onChangeDate = (date) => {
    if (date) {
      const dateWithTime = date.hour(9).minute(0).second(0);
      const timestamp = dateWithTime.valueOf();
      console.log("格式化日期:", dateWithTime.format("YYYY-MM-DD HH:mm:ss"));
      console.log("时间戳:", timestamp);
      setSelectedTimestamp(timestamp);
    } else {
      setSelectedTimestamp(null);
    }
  };

  // 提交
  const handleSubmit = async () => {
    if (
      selectedAccount === null ||
      selectedAccount === undefined ||
      selectedAccount === ""
    ) {
      message.warning("Please select a vendor.");
      return;
    }
    if (!selectedRowKeys) {
      message.warning("Please select a date.");
      return;
    }

    if (!selectedRowKeys || selectedRowKeys.length === 0) {
      message.warning("Please select at least one item from the table.");
      return;
    }
    setBtnLoading(true);
    try {
      const data = {
        vendorId: selectedAccount,
        maintenanceId: selectedRowKeys[0],
        clockTime: selectedTimestamp,
      };
      const response = await http.post(`${api.getVendorClockAdd}`, data);
      console.log(response);
      if (response.code === "1") {
        message.open({
          type: "success",
          content: "Added successfully",
        });
        setSelectedAccount(null);
        setSelectedRowKeys([]);
        setSelectedTimestamp(null);
        fetchData(1, 25);
      }
    } catch (err) {
      setError(err);
    } finally {
      setBtnLoading(false);
    }
  };
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const token = localStorage.getItem("token");
    // if (token) {

    getSearchVendor();
    // fetchData(1, 25);
    // } else {
    //   console.error("未找到 token，无法获取数据");
    //   setLoading(false);
    // }
  }, []);
  return (
    <div>
      <div className="vendorMain">
        <div className="vendorTitle">
          <HomeOutlined style={{ marginRight: 8 }} />
          Vendor Clock Content
        </div>
        <div className="vendorContent">
          <div style={{ marginBottom: 16 }}>
            <span className="tiptext">*</span>Vendor:{" "}
            <Select
              showSearch
              style={{ width: 500, marginLeft: "10px" }}
              placeholder="Select Vendor"
              optionFilterProp="children"
              onChange={handleChangeUpdata}
              onClear={handleClear}
              onSearch={stepSearchChange}
              allowClear
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              value={selectedAccount}
              options={accountData}
            />
          </div>
          <div className="ClockDate">
              {" "}
              <span className="tiptext">*</span> Clock in Date:
              <DatePicker
                onChange={onChangeDate}
                value={selectedTimestamp ? moment(selectedTimestamp) : null}
                showTime={false}
                format="MM/DD/YYYY"
                placeholder="Search  Date"
                style={{ marginLeft: "20px",width:"450px" }}
              />
            </div>
          <div>
            <span className="tiptext">*</span> Maintenance Request:
            <Table
              rowSelection={rowSelection}
              loading={tableLoading}
              columns={columns.filter((col) => col.hidden === false)}
              dataSource={[...filteredData]}
              pagination={{
                showQuickJumper:true,
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: pagination.total,
                showTotal: (total) => {
                  return `Total: ${total} items`;
                },
                showSizeChanger: true,
              }}
              rowKey="id"
              onChange={handleTableChange}
              scroll={{
                x: "max-content",
                y: "calc(100vh - 350px)",
              }}
              className="my-table-vendorADD"
            />
          
          </div>
          <div className="footButton">
            <Button type="primary" loading={btnLoading} onClick={handleSubmit}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorClock;
